import React, { useState } from "react";
import { History } from "lucide-react";
import Button from "./ui/button";
import HistorialEmbarcacionesModal from "./HistorialEmbarcacionesModal";

const HistorialEmbarcacionesButton = ({ clienteId }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        className="bg-azul-lago hover:bg-azul-claro"
        onClick={() => setOpen(true)}
      >
        <History className="mr-2 h-4 w-4" />
        Ver historial
      </Button>
      <HistorialEmbarcacionesModal
        open={open}
        onClose={() => setOpen(false)}
        clienteId={clienteId}
      />
    </>
  );
};

export default HistorialEmbarcacionesButton;
